/* eslint-disable prettier/prettier */
export const getPhoneScreensByOrg = /* GraphQL */ `
  query GetPhoneScreensbyOrg(
    $orgID: ID!
    $statusDate: ModelPhoneScreenByOrgStatusDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $phoneScreensFilter: ModelPhoneScreenFilterInput
    $interviewersFilter: ModelInterviewerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getOrganization(id: $orgID) {
      id
      name
      phoneScreens(
        statusDate: $statusDate,
        filter: $phoneScreensFilter,
        limit: $limit,
        nextToken: $nextToken,
        sortDirection: $sortDirection
      ) {
        items {
          id
          date
          createdAt
          candidates {
            items {
              city
              hireurl
              id
              level
              name
            }
          }
          comments(filter: { or: [{ commentType: { eq: EVENT } }, { commentType: { eq: CANCELLATION } }] }) {
            items {
              id
            }
          }
          updatedAt
          eventendtime
          eventstarttime
          designatedRCID
          designatedRC {
            id
            alias
            name
          }
          orgID
          status
          locked
          availabilityID
          restrictedevent
          eventConfig {
            id
            candidateLevels
            name
            description
            duration
            createdAt
            updatedAt
            isActive
            orgID
            participantConfigs {
              items {
                id
                orgID
                isActive
                name
                description
                calibrationConfigID
                createdAt
                updatedAt
              }
            }
          }
          interviewers(filter: $interviewersFilter) {
            items {
              id
              startDateTime
              endDateTime
              interviewerRole
              participantConfigID
              isBarRaiserInterviewer
              sourceOrgID
              profile {
                id
                alias
                languages(
                  limit: 1000,
                  filter: {
                    or: [
                      { reading: { eq: FLUENT_OR_NATIVE }},
                      { speaking: { eq: FLUENT_OR_NATIVE }},
                      { writing: { eq: FLUENT_OR_NATIVE }},
                    ]
                  }
                ) {
                  items {
                    isoCode
                    reading
                    speaking
                    writing
                  }
                }
                name
                preferredTimezoneId
                title
              }
            }
          }
          languages {
            items {
              isoCode
              readingRequired
              speakingRequired
              writingRequired
            }
          }
          taglist
        }
        nextToken
      }
    }
  }
`;

export const getPhoneScreensByInterviewerProfile = /* GraphQL */ `
  query getPhoneScreensByInterviewerProfile(
    $profileID: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listInterviewersByProfile(
      profileID: $profileID
      sortDirection: $sortDirection
      filter: { phoneScreenID: { attributeExists: true } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        phoneScreen {
          id
          date
          createdAt
          candidates {
            items {
              city
              hireurl
              id
              level
              name
            }
          }
          comments(filter: { or: [{ commentType: { eq: EVENT } }, { commentType: { eq: CANCELLATION } }] }) {
            items {
              id
            }
          }
          updatedAt
          eventendtime
          eventstarttime
          designatedRCID
          restrictedevent
          designatedRC {
            id
            alias
            name
          }
          orgID
          status
          locked
          availabilityID
          eventConfig {
            id
            candidateLevels
            name
            description
            duration
            createdAt
            updatedAt
            isActive
            orgID
            participantConfigs {
              items {
                id
                orgID
                isActive
                name
                description
                calibrationConfigID
                createdAt
                updatedAt
              }
            }
          }
          interviewers {
            items {
              id
              interviewerRole
              participantConfigID
              isBarRaiserInterviewer
              startDateTime
              endDateTime
              sourceOrgID
              profile {
                id
                alias
                languages(
                  limit: 1000,
                  filter: {
                    or: [
                      { reading: { eq: FLUENT_OR_NATIVE }},
                      { speaking: { eq: FLUENT_OR_NATIVE }},
                      { writing: { eq: FLUENT_OR_NATIVE }},
                    ]
                  }
                ) {
                  items {
                    isoCode
                    reading
                    speaking
                    writing
                  }
                }
                name
                preferredTimezoneId
                title
              }
            }
          }
          languages {
            items {
              isoCode
              readingRequired
              speakingRequired
              writingRequired
            }
          }
          taglist
        }
      }
      nextToken
    }
  }
`;

export const getOrgPhoneScreenDurationConfigs = /* GraphQL */ `
  query GetOrgPhoneScreenDurationConfigs(
    $orgID: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listConfigsByOrgType(
      orgID: $orgID
      configType: { eq: "PHONESCREEN_CONFIG" }
      sortDirection: $sortDirection
      filter: {
        and: [
          { isActive: { eq: true } },
          { duration: { gt: 60 } },
        ]
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        duration
      }
      nextToken
    }
  }
`;

export const getPhoneScreenConfigsByOrg = /* GraphQL */ `
  query GetPhoneScreenConfigsByOrg(
    $orgID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrgLoopPSConfigurationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConfigsByOrgType(
      orgID: $orgID
      configType: { eq: "PHONESCREEN_CONFIG" }
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        configType
        group
        isActive
        isPushRouting
        brMode
        candidateLevels
        name
        description
        duration
        participantConfigs {
          items {
            id
            orgID
            configType
            group
            isActive
            name
            description
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getPhoneScreenConfigDefinition = /* GraphQL */ `
  query GetOrgLoopPSConfigurations($id: ID!) {
    getOrgLoopPSConfigurations(id: $id) {
      id
      orgID
      group
      isActive
      brMode
      candidateLevels
      name
      description
      duration
      isPushRouting
      participantConfigIDs
      participantConfigs {
        items {
          id
          orgID
          configType
          group
          isActive
          name
          description
          calibrationConfigID
          calibrationConfig {
            id
            orgID
            configType
            group
            isActive
            name
            description
            maxShadowPoolSize
            minShadows
            minReverseShadows
            minShepherdReviews
            minIndependent
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const listProfileAvailabilityByOrg = /* GraphQL */ `
  query listProfileAvailabilityByOrg(
    $orgID: ID!
    $limit: Int
    $nextToken: String
  ) {
    listProfilesByOrgV2(
      orgID: $orgID
      filter: { role: { contains: INTERVIEWER } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        profile {
          id
          alias
          name
          email
          level
          preferredTimezoneId
          availabilities(filter: { expired: { ne: true } }, limit: 1000) {
            items {
              availabilityClose
              availabilityDate
              availabilityOpen
              availabilitySeriesID
              createdAt
              expired
              hireurl
              id
              recurringEndDate
              recursion
              requester
              rrule
              sendCalendarInvite
              state
              updatedAt
            }
          }
          calibrations(filter: { status: { ne: NOT_CALIBRATED } }limit: 1000) {
            items {
              calibrationId
              independentCount
              reverseShadowCount
              reviewCount
              shadowCount
              status
            }
          }
          status
          title
        }
      }
      nextToken
    }
  }
`;

export const getProfileAvailability = /* GraphQL */ `
  query GetProfileAvailability($id: ID!) {
    getProfileAvailability(id: $id) {
      id
      profile {
        id
        alias
        name
        email
        level
        preferredTimezoneId
        calibrations {
          items {
            calibrationId
            independentCount
            reverseShadowCount
            reviewCount
            shadowCount
            status
          }
        }
        title
      }
      requester
      hireurl
      state
      sendCalendarInvite
      expired
      availabilitySeriesID
      availabilityDate
      recurringEndDate
      availabilityOpen
      availabilityClose
      recursion
      rrule
      createdAt
      updatedAt
    }
  }
`;

export const getPhoneScreenInterviewers = /* GraphQL */ `
  query GetInterviewersByPhoneScreen(
    $eventID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelInterviewerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getPhoneScreen(id: $eventID) {
      interviewers(
        sortDirection: $sortDirection
        filter: $filter
        limit: $limit
        nextToken: $nextToken
      ) {
        items {
          id
          profileID
          participantConfigID
          interviewerRole
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const getPhoneScreen = /* GraphQL */ `
  query GetPhoneScreen($id: ID!) {
    getPhoneScreen(id: $id) {
      availabilityID
      id
      candidates {
        items {
          city
          hireurl
          id
          level
          name
        }
      }
      comments(filter: { or: [{ commentType: { eq: EVENT } }, { commentType: { eq: CANCELLATION } }] }) {
        items {
          id
        }
      }
      orgID
      date
      eventstarttime
      eventendtime
      status
      locked
      designatedRCID
      designatedRC {
        id
        alias
        name
      }
      interviewers {
        items {
          id
          profile {
            id
            alias
            languages(
              limit: 1000,
              filter: {
                or: [
                  { reading: { eq: FLUENT_OR_NATIVE }},
                  { speaking: { eq: FLUENT_OR_NATIVE }},
                  { writing: { eq: FLUENT_OR_NATIVE }},
                ]
              }
            ) {
              items {
                isoCode
                reading
                speaking
                writing
              }
            }
            name
            preferredTimezoneId
            title
          }
          startDateTime
          endDateTime
          interviewerRole
          isBarRaiserInterviewer
          sendCalendarInvite
          participantConfigID
          sourceOrgID
        }
      }
      eventConfig {
        id
        orgID
        configType
        group
        isActive
        brMode
        candidateLevels
        name
        description
        duration
        participantConfigIDs
        participantConfigs {
          items {
            id
            orgID
            configType
            group
            isActive
            name
            description
            calibrationConfigID
            calibrationConfig {
              id
              orgID
              configType
              group
              isActive
              candidateLevels
              name
              description
              maxShadowPoolSize
              minIndependent
              minShadows
              minReverseShadows
              minShepherdReviews
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      languages {
        items {
          isoCode
          readingRequired
          speakingRequired
          writingRequired
        }
      }
      restrictedevent
      taglist
      createdAt
      updatedAt
    }
  }
`;

export const getCommentsByPhoneScreen = /* GraphQL */ `
  query getCommentsByPhoneScreen(
    $phoneScreenId: ID!
    $limit: Int
    $nextToken: String
  ) {
    getPhoneScreen(id: $phoneScreenId) {
      comments(
        filter: { or: [{ commentType: { eq: CANCELLATION } }, { commentType: { eq: EVENT } }] },
        limit: $limit
        nextToken: $nextToken
      ) {
        items {
          id
          content
          profile {
            id
            alias
            email
            name
            title
          }
          restricted
          loopEventID
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
